module.exports = __webpack_public_path__ + "static/img/小雪.62cd9f75.svg";